'use client';

import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@phosphor-icons/react';
import { Briefcase, House, Storefront } from '@phosphor-icons/react';
import Link from 'next/link';
import type { ReactNode } from 'react';
type NullableString = string | null | undefined;
type ImprintContentProps = {
  company: string;
  address: NullableString[];
  vatId?: NullableString;
  registrationId?: NullableString;
  associationId?: NullableString;
  privacyLink?: NullableString;
  termsLink?: NullableString;
};
export function ImprintContent(t0) {
  const $ = _c(20);
  const {
    company,
    address,
    vatId,
    registrationId,
    associationId,
    termsLink,
    privacyLink
  } = t0;
  let t1;
  if ($[0] !== address) {
    t1 = address.map(_temp);
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== company || $[3] !== t1) {
    t2 = <IconSection Icon={House} title={company} text={t1} />;
    $[2] = company;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== vatId) {
    t3 = <IconSection Icon={Briefcase} title="Umsatzsteuer-ID" text={vatId} />;
    $[5] = vatId;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== registrationId) {
    t4 = <IconSection Icon={Storefront} title="Handelsregister" text={registrationId} />;
    $[7] = registrationId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== associationId) {
    t5 = <IconSection Icon={Storefront} title="Vereinsregister" text={associationId} />;
    $[9] = associationId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== privacyLink || $[12] !== termsLink) {
    t6 = <TermsPrivacyLinks termsLink={termsLink} privacyLink={privacyLink} />;
    $[11] = privacyLink;
    $[12] = termsLink;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className="flex flex-col flex-wrap *:my-4 sm:max-h-48 sm:*:w-1/2">{t2}{t3}{t4}{t5}{t6}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
function _temp(line) {
  return <span key={line} className="block">{line}</span>;
}
type IconSection = {
  Icon: Icon;
  title: string;
  text: ReactNode;
};
const IconSection = t0 => {
  const $ = _c(12);
  const {
    Icon,
    title,
    text
  } = t0;
  if (!text) {
    return null;
  }
  let t1;
  if ($[0] !== Icon) {
    t1 = <div className="size-6"><Icon size={24} /></div>;
    $[0] = Icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <h5 className="mb-1 font-heading5">{title}</h5>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== text) {
    t3 = <p className="font-body-copy">{text}</p>;
    $[4] = text;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="ml-4">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <div className="mb-8 flex items-start justify-start last:mb-0">{t1}{t4}</div>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
type TermsPrivacyLinksProps = {
  termsLink: NullableString;
  privacyLink: NullableString;
};
function TermsPrivacyLinks(t0) {
  const $ = _c(7);
  const {
    termsLink,
    privacyLink
  } = t0;
  if (!termsLink || !privacyLink) {
    return null;
  }
  let t1;
  if ($[0] !== termsLink) {
    t1 = <Link href={termsLink} target="_blank" className="underline">AGB</Link>;
    $[0] = termsLink;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== privacyLink) {
    t2 = <Link href={privacyLink} target="_blank" className="underline">Datenschutz</Link>;
    $[2] = privacyLink;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <IconSection Icon={Storefront} title="Weitere Infos vom Merchant" text={<>{t1}{" und "}{t2}</>} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}